export * from "./ed-rx.component";
